import { render, staticRenderFns } from "./projectProcess.vue?vue&type=template&id=06dfcf94&scoped=true"
import script from "./projectProcess.vue?vue&type=script&lang=js"
export * from "./projectProcess.vue?vue&type=script&lang=js"
import style0 from "./projectProcess.vue?vue&type=style&index=0&id=06dfcf94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dfcf94",
  null
  
)

export default component.exports